/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Image_Subtitles_DescInputs */



/**
* | output |
* | --- |
* | "PNG images with BDN and FCP XML" |
*
* @param {File_Export_Image_Subtitles_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_image_subtitles_desc = /** @type {((inputs?: File_Export_Image_Subtitles_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Image_Subtitles_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Images PNG avec XML BDN et FCP")
	if (locale === "de") return /** @type {LocalizedString} */ ("PNG-Bilder mit BDN-XML und FCP-XML")
	if (locale === "it") return /** @type {LocalizedString} */ ("Immagini PNG con BDN XML e FCP XML")
	if (locale === "ru") return /** @type {LocalizedString} */ ("PNG-изображения с BDN XML и FCP XML")
	if (locale === "es") return /** @type {LocalizedString} */ ("Imágenes PNG con BDN XML y FCP XML")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("带有 BDN XML 和 FCP XML 的 PNG 图像")
	if (locale === "ja") return /** @type {LocalizedString} */ ("BDN XML と FCP XML を使用した PNG 画像")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बीडीएन और एफसीपी एक्सएमएल के साथ पीएनजी छवियां")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Imagens PNG com XML BDN e FCP")
	return /** @type {LocalizedString} */ ("PNG images with BDN and FCP XML")
});